export const starRatingText = (reviewCount, fullRatingsDisplayBool) => {
  const reviewNum = fullRatingsDisplayBool
    ? `${reviewCount} `
    : `(${reviewCount})` // with or w/o parens
  const reviewNumText = fullRatingsDisplayBool
    ? reviewCount === 1
      ? 'review'
      : 'reviews'
    : ''
  return reviewNum + reviewNumText
}
